import React, { useState } from 'react';
import TeacherUserButtons from './TeacherUserButtons';
import StudentUserButtons from './StudentUserButtons';
import MenuSearch from '../search/MenuSearch';

const User = ({ auth: { firstname, lastname, patronymic, isTeacher }, signOut, history }) => {
  const [searchOpen, setSearchOpen] = useState(false);

  return (
    <div className="header-user">
      <p className="header-user__user">
        {lastname} {firstname} {patronymic}
      </p>

      <div className="header-user__right">
        <div
          className="header__find-user"
          onClick={() => setSearchOpen(true)}
          role="button"
          title="Поиск по разделам"
        />
        {isTeacher
          ? <TeacherUserButtons signOut={signOut} history={history} />
          : <StudentUserButtons signOut={signOut} history={history} />
        }
      </div>

      {searchOpen && <MenuSearch onClose={() => setSearchOpen(false)} />}
    </div>
  );
};

export default User;
